module.exports = __webpack_public_path__ + "media/images/icons/bars-9dc3086dfe0edd662fb56442f847b9c9.svg";